import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  datePicker: {
    minWidth: "100%",
    marginTop: theme.spacing(2),
  },
  showGraphButton: {
    minWidth: "75%",
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginTop: "10px", 
    marginBottom: "10px",
  },
  textFieldRoot: {
    "& > div.MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      // default paddingRight was 39px since clear icon was positioned absolute
      paddingRight: "9px",
      fontSize: "0.9rem",

      // Search icon
      "& button": {
        order: 3, // order 3 means the search icon will appear after the clear icon which has an order of 2
        fontSize: "0.9rem"
      },
      // Clear icon
      "& > div.MuiAutocomplete-endAdornment": {
        position: "relative", // default was absolute. we make it relative so that it is now within the flow of the other two elements
        order: 2,
      },
    },
},
RadioButtonLabel:{
  "& .MuiFormControlLabel-label":{
    fontSize: "0.9rem"
  }
}
}), {index: 1});
